import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";
import DummyUser from "../../Assets/User.webp";
import TableContainer from "../../Components/TableContainer";
import Swal from "sweetalert2";
import block from "../../Assets/common/Block.png";
import unBlock from "../../Assets/common/UnBlock.png";
import { toast } from "react-toastify";
const ReportUserDetails = () => {
  const pageSize = 15;
  const location = useLocation();
  const id = location?.state?.id;
  const [user, setUser] = useState(location?.state?.user || {});
  const list = location?.state?.get
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [page, setPage] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(true);
  const handlePageChange = (newValue) => {
    setPage(newValue);
  };
  const handleBlockUnBlock = async (isStatus) => {
    const newStatus = isStatus;
    Swal.fire({
      title: "Are you sure?",
      text:
        newStatus === 2
          ? "You want to block this user"
          : newStatus === 1 && "You want to unblock this user",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#46adf2",
      cancelButtonColor: "#5b5d5d",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const formData = new FormData();
          formData.append("report_to", id);
          formData.append("is_block", newStatus);
          const res = await AxiosInstance.post(ApiList.BLOCK_USER, formData);
          if (res?.data?.s) {
            toast.success(
              `User ${
                newStatus === 2 ? "blocked" : newStatus === 1 && "unblocked"
              } Sucessfully !.`
            );
          }
          setUser((prevUser) => ({
            ...prevUser,
            status: newStatus,
          }));
          console.log(res);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };
  const getReportedUserDetails = async () => {
    setLoading(true);
    try {
      const params = {
        select:
          "ru.id,ru.report_by,u.fname,u.lname,u.image,u.email,ru.reason,ru.description",
        from: "report_users AS ru JOIN users AS u ON ru.report_by = u.id",
        arg: "ru.report_to = ?",
        skip: page * pageSize,
        limit: pageSize,
        total: 1,
        prms: [id],
      };
      const response = await AxiosInstance.post(ApiList.USER_GET, params);
      if (response?.data?.s === 1) {
        const formattedUsers = response?.data?.r?.map((user, index) => ({
          rowid: index + 1 + page * pageSize,
          ...user,
        }));
        setData(formattedUsers);
        if (params.skip === 0) {
          const totalCount = response?.data?.total || 0;
          localStorage.setItem("totalCount", totalCount);
          setTotalData(totalCount);
        } else {
          const totalCountFromStorage = localStorage.getItem("totalCount");
          setTotalData(
            totalCountFromStorage ? Number(totalCountFromStorage) : 0
          );
        }
        setLoading(false);
      } else {
        setData([]);
        setTotalData(0);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    getReportedUserDetails();
  }, [page]);
  const columns = [
    {
      field: "rowid",
      headerName: "Sr.No",
      width: 80,
      align: "center",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "image",
      headerName: "Profile",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Avatar
          sx={{
            width: "40px",
            height: "40px",
            objectFit: "contain",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={
              params?.row?.image
                ? `${ApiList.IMG_URL}${params?.row?.image}`
                : DummyUser
            }
            style={{ width: "100%", height: "100%" }}
          ></img>
        </Avatar>
      ),
    },
    {
      field: "name",
      headerName: "Reported User",
      minWidth: 150,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const name = `${params?.row?.fname || ""} ${params?.row?.lname || ""}`;
        const truncatedCaption =
          name?.length > 20 ? `${name.substring(0, 20)}...` : name;
        return (
          <Tooltip title={`${params?.row?.fname} ${params?.row?.lname}`}>
            {truncatedCaption}
          </Tooltip>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 150,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const email = params.row.email;
        const truncatedCaption =
          email?.length > 20 ? `${email.substring(0, 20)}...` : email;
        return <Tooltip title={params?.row?.email}>{truncatedCaption}</Tooltip>;
      },
    },
    {
      field: "reason",
      headerName: "Reason",
      width: 150,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const reason = params.row.reason;
        const truncatedCaption =
          reason?.length > 20 ? `${reason.substring(0, 20)}...` : reason;
        return (
          <Tooltip title={params?.row?.reason}>{truncatedCaption}</Tooltip>
        );
      },
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 200,
      // headerClassName: "leftAlignHeader",
      cellClassName: "center",
      renderCell: (params) => {
        const description = params.row.description;
        const truncatedCaption =
          description?.length > 20
            ? `${description.substring(0, 20)}...`
            : description;
        return (
          <Tooltip title={params?.row?.description}>{truncatedCaption}</Tooltip>
        );
      },
    },
  ];
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: "#B9CC0310",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: "100%",
            p: 2,
            background: "#b9cc0310",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon sx={{ color: "#000", fontSize: "28px" }} />
          </IconButton>
          <Typography
            sx={{
              fontSize: { xs: "18px", md: "28px" },
              fontWeight: "300",
              color: "#000",
            }}
          >
            Reported User Details
          </Typography>
        </Box>
        <Box sx={{ width: "100%", height: "calc(100vh - 74px)", p: 2 }}>
          <Box
            sx={{
              display: "flex",
              background: "#b9cc0360",
              borderRadius: "10px",
              p: 2,
              gap: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ width: "80px", height: "80px" }}>
                <img
                  src={
                    user?.image
                      ? `${ApiList.IMG_URL}${user?.image}`
                      : DummyUser
                  }
                  style={{ width: "100%", height: "100%" }}
                ></img>
              </Avatar>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <Typography>
                <span style={{ color: "#000" }}>Name :</span>{" "}
                <span
                  style={{ color: "#000" }}
                >{`${user?.fname} ${user?.lname}`}</span>
              </Typography>
              <Divider sx={{ border: "1px solid #000" }} />
              <Typography>
                <span style={{ color: "#000" }}>Email :</span>{" "}
                <span style={{ color: "#000" }}>{user?.email}</span>
              </Typography>
              <Divider sx={{ border: "1px solid #000" }} />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              <Typography>
                <span style={{ color: "#000" }}>Account Status :</span>{" "}
                <span style={{ color: user?.status === 1 ? "#FF9100" : "red" }}>
                  {user?.status === 1 ? "Unblocked" : "Blocked"}
                </span>
              </Typography>
              <Divider sx={{ border: "1px solid #000" }} />

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography>
                  <span style={{ color: "#000" }}>Action :</span>{" "}
                </Typography>
                <Box sx={{ display: "flex", width: "100px", height: "auto" }}>
                  {user?.status === 1 ? (
                    <IconButton
                      sx={{ width: "40px", height: "40px" }}
                      onClick={() => handleBlockUnBlock(2)}
                    >
                      <img
                        src={block}
                        style={{ width: "100%", height: "100%" }}
                      ></img>
                    </IconButton>
                  ) : (
                    user?.status === 2 && (
                      <IconButton
                        sx={{ width: "40px", height: "40px" }}
                        onClick={() => handleBlockUnBlock(1)}
                      >
                        <img
                          src={unBlock}
                          style={{ width: "100%", height: "100%" }}
                        ></img>
                      </IconButton>
                    )
                  )}
                </Box>
              </Box>
              <Divider sx={{ border: "1px solid #000" }} />
            </Box>
          </Box>
          <Box
            sx={{
              height: "calc(100vh - 250.67px)",
              width: "100%",
              mt: 2,
              overflow: "scroll",
            }}
          >
            <TableContainer
              columns={columns}
              rows={data}
              handlePageChange={handlePageChange}
              page={page}
              loading={loading}
              totalData={totalData}
              pageSize={pageSize}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ReportUserDetails;
